"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlayRefSliceEnd = exports.OverlayRefSliceStart = void 0;
class OverlayRefSliceStart {
    constructor(slice) {
        this.slice = slice;
    }
}
exports.OverlayRefSliceStart = OverlayRefSliceStart;
class OverlayRefSliceEnd {
    constructor(slice) {
        this.slice = slice;
    }
}
exports.OverlayRefSliceEnd = OverlayRefSliceEnd;
